import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChangeRequestStatusType } from 'src/app/enum/change-request-status-type';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ServiceChangeRequestService } from 'src/app/services/service-change-request.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-trace-removal-operation',
  templateUrl: './trace-removal-operation.component.html',
  styleUrls: ['./trace-removal-operation.component.scss']
})
export class TraceRemovalOperationComponent implements OnInit {
searchform:FormGroup
form:FormGroup;
data:any;
isshow=false;
ipAddress:any;
changerequest:ChangeRequestStatusType;
  constructor(
    private formBuilder:FormBuilder,
    private applicationDataService:ApplicationDataService,
    private utilityService:UtilityService,
    private serviceChangeRequestService:ServiceChangeRequestService,
    private toastr: NotificationService,

  ) { }

  ngOnInit(): void {
    this.searchform=this.formBuilder.group({
      searchQuery:[null,Validators.required],
    })
    this.form=this.formBuilder.group({
      customerName:[],
      customerCode:[],
      applicationReferenceNumber:[],
      serviceProvider:[],
      serviceReferenceNumber:[],
      currentProductName:[],
      upgradeOrDowngradeProductName:[],
      changeRequestStatusTypeName:[],
      requestedDate:[],
      approveCancellationDate:[],
      receiverCustomerName:[],
      transferStatusName:[],
      newApplicationReferenceNumber:[],
      newServiceProvider:[],
      oldAddress:[],
      newAddress:[],
      addressChangeStatusName:[],
    })
    this.form.disable();
    this.getip();
  }

  getip(){
    this.utilityService.getIpAddress().subscribe((result)=>{
      this.ipAddress=result;
    })

  }
  searchinput(){
    if(this.searchform.valid){
      this.data=null;
      this.isshow=false;
    let data=this.searchform.value.searchQuery;
    this.applicationDataService.getApplicationForTraceRemovalOperation(data).subscribe((result)=>{
      if(result){
        this.isshow=true
      this.data=result;
      this.form.patchValue(this.data);
    }
    else{
      this.toastr.showError('No Trace for this Application')
    }
    })
  }
}
  clearFilter(){
    this.searchform.reset();
    this.data=null;
    this.isshow=false;
  }
  save(){

    var postData:any = {};
    postData.applicationId = this.data.applicationId;
    postData.TraceRemovalOperationType = this.data.traceRemovalOperationType;
    postData.ipAddress = this.ipAddress;

    if (this.data.traceRemovalOperationType == 1 || this.data.traceRemovalOperationType == 2) {

        var postdataforservice:any = {};
                        
        postdataforservice.id = this.data.serviceChangeRequestId

        if (this.data.traceRemovalOperationType == 2) {

            postdataforservice.changeRequestStatus = ChangeRequestStatusType.CancellationRejected
        }
        else if (this.data.changeRequestStatus == 32 || this.data.changeRequestStatus == 34) {

            postdataforservice.changeRequestStatus = ChangeRequestStatusType.ServiceUpgradeCancelled
        }
        else if (this.data.changeRequestStatus == 33 || this.data.changeRequestStatus == 35) {

            postdataforservice.changeRequestStatus = ChangeRequestStatusType.ServiceDowngradeCancelled
        }

        postdataforservice.applicationId=this.data.applicationId
        postdataforservice.reason = "Through API";
        this.serviceChangeRequestService.save(postdataforservice).subscribe((result)=>{
          if (result) {
            if (result.result != undefined) {
                if (result.result.effective_date != null && result.result.orderreference == null) {
                  this.toastr.showError(result.result.effective_date);
                }
              }
              else{
                this.applicationDataService.saveRemovalOperation(postData).subscribe((result)=>{
                  if(result){
                    this.toastr.showSuccess("Trace Removal Operation Successfully Done!")
                    this.clearFilter();
                  }
                  else
                    this.toastr.showError("Opps Something went wrong")
                })
              }
            }
            else
            this.toastr.showError("Opps Something went wrong")
        })
  }
  else{
    this.applicationDataService.saveRemovalOperation(postData).subscribe((result)=>{
      if(result){
        this.toastr.showSuccess("Trace Removal Operation Successfully Done!")
        this.clearFilter();
      }
      else
      this.toastr.showError("Opps Something went wrong")
    })
  }

}
}